<template lang="pug">
  router-view
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'view-control-users',

  computed: {
    ...mapGetters(['userGroups']),
  },

  methods: {
    ...mapMutations(['setBreadcrumbsRouteTitle']),
  },

  created() {
    this.setBreadcrumbsRouteTitle({
      'control.users': ({ title }) => {
        let groupId = this.$route.params.groupId;
        let currentUserGroup = this.userGroups.find(groupId);
        return currentUserGroup ? title + ': ' + currentUserGroup.title : title;
      },
    });
  },
};
</script>
